import { useInfiniteQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { GetCreateConversationUsersInfiniteQueryProps } from './chatService';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function useGetCreateConversationUsersInfinite(props: GetCreateConversationUsersInfiniteQueryProps) {
  const { name, enabled = true } = props;
  const getCreateConversationUsersInfinite = useInfiniteQuery({
    queryKey: [ChatKey.CHAT_CONVERSATIONS_USERS_INFINITE, name],
    queryFn: ({ pageParam }) => ChatService.getCreateConversationUsers({ ...pageParam, name }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
    enabled: enabled,
  });

  const errorMessage = useErrorMessage(getCreateConversationUsersInfinite.error);

  return { ...getCreateConversationUsersInfinite, errorMessage };
}
